import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { Routes, RouterModule } from "@angular/router";

import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";
import { RtlLayoutComponent } from "./layouts/rtl-layout/rtl-layout.component";
import { environment } from 'src/environments/environment';
import { LoginGuardGuard } from './services/login-guard.guard';


const routes: Routes = [
  
  {
    path: "",
    canActivate: [LoginGuardGuard],
    redirectTo: "dashboard",
    pathMatch: "full"
  },
  {
    path: "",
    component: AdminLayoutComponent,
    children: [
      {
        path: "",
        canActivate: [LoginGuardGuard],
        loadChildren:
          "./pages/dashboard/dashboard.module#DashboardModule"
      },
      {
        path: "components",
        loadChildren:
          "./pages/components/components.module#ComponentsPageModule"
      },
      {
        path: "forms",
        loadChildren: "./pages/forms/forms.module#Forms"
      },
      {
        path: "tables",
        loadChildren: "./pages/tables/tables.module#TablesModule"
      },
      {
        path: "maps",
        loadChildren: "./pages/maps/maps.module#MapsModule"
      },
      {
        path: "widgets",
        loadChildren: "./pages/widgets/widgets.module#WidgetsModule"
      },
      {
        path: "charts",
        loadChildren: "./pages/charts/charts.module#ChartsModule"
      },
      {
        path: "calendar",
        loadChildren:
          "./pages/calendar/calendar.module#CalendarModulee"
      },
      // {
      //   path: "users",
      //   loadChildren:
      //     "./pages/admin-medios/users/users.module#UsersModule"
      // },
      // {
      //   path: "users/user-detail",
      //   loadChildren:
      //     "./pages/admin-medios/users/user-detail/user-detail.module#UserDetailModule"
      // },
      // {
      //   path: "users/user-detail/:mode/:userId",
      //   loadChildren:
      //     "./pages/admin-medios/users/user-detail/user-detail.module#UserDetailModule"
      // },
      {
        path: "mentions",
        loadChildren: "./pages/admin-medios/mentions/mentions.module#MentionsModule"
      },
      {
        path: "mentions/mentions-detail",
        loadChildren:
          "./pages/admin-medios/mentions/mentions-detail/mentions-detail.module#MentionsDetailModule"
      },
      {
        path: "mentions/mentions-detail/:mentionId/:mode",
        loadChildren:
          "./pages/admin-medios/mentions/mentions-detail/mentions-detail.module#MentionsDetailModule"
      },
      {
        path: "promotions",
        loadChildren: "./pages/admin-medios/promotions/promotions.module#PromotionsModule"
      },
      {
        path: "promotions/promotions-detail",
        loadChildren: "./pages/admin-medios/promotions/promotions-detail/promotions-detail.module#PromotionsDetailModule"
      },
      {
        path: "promotions/promotions-detail/:promotionId/:mode",
        loadChildren: "./pages/admin-medios/promotions/promotions-detail/promotions-detail.module#PromotionsDetailModule"
      },
      {
        path: "interviews",
        loadChildren: "./pages/admin-medios/interviews/interviews.module#InterviewsModule"
      },
      {
        path: "interviews/interviews-detail",
        loadChildren: "./pages/admin-medios/interviews/interviews-detail/interviews-detail.module#InterviewsDetailModule"
      },
      {
        path: "interviews/interviews-detail/:interviewId/:mode",
        loadChildren: "./pages/admin-medios/interviews/interviews-detail/interviews-detail.module#InterviewsDetailModule"
      },
      {
        path: "segments",
        loadChildren: "./pages/admin-medios/segments/segments.module#SegmentsModule"
      },
      {
        path: "segments/segments-detail",
        loadChildren: "./pages/admin-medios/segments/segments-detail/segments-detail.module#SegmentsDetailModule"
      },
      {
        path: "segments/segments-detail/:segmentId/:mode",
        loadChildren: "./pages/admin-medios/segments/segments-detail/segments-detail.module#SegmentsDetailModule"
      },
      {
        path: "adshots",
        loadChildren: "./pages/admin-medios/adshots/adshots.module#AdshotsModule"
      },
      {
        path: "adshots/adshots-detail",
        loadChildren: "./pages/admin-medios/adshots/adshots-detail/adshots-detail.module#AdshotsDetailModule"
      },
      {
        path: "adshots/adshots-detail/:adshotId/:mode",
        loadChildren: "./pages/admin-medios/adshots/adshots-detail/adshots-detail.module#AdshotsDetailModule"
      },
      {
        path: "reports",
        loadChildren: "./pages/admin-medios/reports/reports.module#ReportsModule"
      },
      {
        path: "reports/reports-detail/:parameters",
        loadChildren: "./pages/admin-medios/reports/reports-detail/reports-detail.module#ReportsDetailModule"
      },
      {
        path: "reports/reports-detail/:product/:customerSelected/:campaignSelected/:radioSelected/:shiftSelected",
        loadChildren: "./pages/admin-medios/reports/reports-detail/reports-detail.module#ReportsDetailModule"
      },

      {
        path: "staff-mentions",
        loadChildren: "./pages/staff/staff-mentions/staff-mentions.module#StaffMentionsModule"
      },
      {
        path: "staff-mentions/staff-mentions-detail",
        loadChildren:
          "./pages/staff/staff-mentions/staff-mentions-detail/staff-mentions-detail.module#StaffMentionsDetailModule"
      },
      {
        path: "staff-promotions",
        loadChildren: "./pages/staff/staff-promotions/staff-promotions.module#StaffPromotionsModule"
      },
      {
        path: "staff-promotions/staff-promotions-detail",
        loadChildren:
          "./pages/staff/staff-promotions/staff-promotions-detail/staff-promotions-detail.module#StaffPromotionsDetailModule"
      },
      {
        path: "staff-interviews",
        loadChildren: "./pages/staff/staff-interviews/staff-interviews.module#StaffInterviewsModule"
      },
      {
        path: "staff-interviews/staff-interviews-detail",
        loadChildren:
          "./pages/staff/staff-interviews/staff-interviews-detail/staff-interviews-detail.module#StaffInterviewsDetailModule"
      },
      {
        path: "staff-segments",
        loadChildren: "./pages/staff/staff-segments/staff-segments.module#StaffSegmentsModule"
      },
      {
        path: "staff-segments/staff-segments-detail",
        loadChildren:
          "./pages/staff/staff-segments/staff-segments-detail/staff-segments-detail.module#StaffSegmentsDetailModule"
      },
      {
        path: "staff-adshots",
        loadChildren: "./pages/staff/staff-adshots/staff-adshots.module#StaffAdshotsModule"
      },
      {
        path: "staff-adshots/staff-adshots-detail",
        loadChildren: "./pages/staff/staff-adshots/staff-adshots-detail/staff-adshots-detail.module#StaffAdshotsDetailModule"
      },
      {
        path: "",
        loadChildren:
          "./pages/config-pages/user/user-profile.module#UserModule"
      },
      {
        path: "",
        loadChildren:
          "./pages/config-pages/timeline/timeline.module#TimelineModule"
      },
      {
        path: "",
        loadChildren:
          "./pages/config-pages/roles/roles.module#RolesModule"
      },
      {
        path: "",
        loadChildren:
          "./pages/config-pages/roles/roles-detail/roles-detail.module#RolesDetailModule"
      },
      {
        path: "",
        loadChildren:
          "./pages/config-pages/radios/radios.module#RadiosModule"
      },
      {
        path: "",
        loadChildren:
          "./pages/config-pages/radios/radios-detail/radios-detail.module#RadiosDetailModule"
      },
      {
        path: "",
        loadChildren:
          "./pages/config-pages/customers/customers.module#CustomersModule"
      },
      {
        path: "",
        loadChildren:
          "./pages/config-pages/customers/customers-detail/customers-detail.module#CustomersDetailModule"
      },
      {
        path: "",
        loadChildren:
          "./pages/config-pages/staff-radios/staff-radios.module#StaffRadiosModule"
      },
      {
        path: "",
        loadChildren:
          "./pages/config-pages/users/users.module#UsersModule"
      },
      {
        path: "",
        loadChildren:
          "./pages/config-pages/users/user-detail/user-detail.module#UserDetailModule"
      }
    ]
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: "./pages/auth-pages/auth-pages.module#AuthPagesModule"
      }
    ]
  },
  // {
  //   path: "",
  //   component: AuthLayoutComponent,
  //   children: [
  //     {
  //       path: "pages",
  //       loadChildren: "./pages/config-pages/pages.module#PagesModule"
  //     }
  //   ]
  // },
  {
    path: "**",
    redirectTo: "dashboard"
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
      scrollOffset: [0, 64]
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
